import useSWR from "swr";
import { getClientTypes } from "./clients-service";
import { UseClientTypesModel } from "./types";

const useClientTypes = (): UseClientTypesModel => {
  const { data, error, mutate } = useSWR(`/client/types`, () =>
    getClientTypes(),
  );

  return {
    data: data?.results ?? [],
    isLoading: !error && !data,
    error,
    mutate,
  };
};

export default useClientTypes;
